import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';
import { getTenantSlug } from '../utils/tenantResolver';
import '../styles/Auth.css';

/**
 * Shown when the user visits a subdomain that is not a registered tenant.
 * No login, register, or app access is allowed for invalid tenants.
 */
const TenantNotFound: React.FC = () => {
  const slug = getTenantSlug();

  const handleGoHome = () => {
    const hostname = window.location.hostname;
    if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
      window.location.href = `${window.location.protocol}//localhost${window.location.port ? ':' + window.location.port : ''}/`;
    } else {
      const parts = hostname.split('.');
      const baseDomain = parts.length >= 2 ? parts.slice(-2).join('.') : hostname;
      window.location.href = `${window.location.protocol}//${baseDomain}${window.location.port ? ':' + window.location.port : ''}/`;
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <Box sx={{ textAlign: 'center', py: 2 }}>
          <Typography variant="h5" component="h1" gutterBottom color="error">
            Page not found
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
            {slug
              ? `The organization "${slug}" is not registered. You cannot sign in or sign up here.`
              : 'This tenant is not registered. You cannot sign in or sign up here.'}
          </Typography>
          <Button
            variant="contained"
            startIcon={<HomeIcon />}
            onClick={handleGoHome}
            sx={{ mt: 1 }}
          >
            Go to main site
          </Button>
        </Box>
      </div>
    </div>
  );
};

export default TenantNotFound;
